// extracted by mini-css-extract-plugin
export default {"formHelpIcon":"FormHelpText_formHelpIcon__DY+rU"};